<template>
  <v-dialog
    v-if="showModalChallenge"
    v-model="showModalChallenge"
    :max-width="dialogWidth"
    overlay-color="bg-dark-overlay"
    overlay-opacity="1"
    content-class="no-shadow overflow-auto hide-scrollbar"
  >
    <div
      v-if="challenge"
      :class="`pb-3 border-0 rounded-lg ${!challenge || !challenge.started_at ? 'bg-dark-modal':''}`"
    >
      <div class="d-flex justify-content-between align-items-center border-0 p-3">
        <ModalTitle class="mb-0 text-white">
          <strong>
            <span v-show="isFinishing"> Concluir</span>
            Desafio | Ciclo {{ challenge.cycle_order }}
          </strong>
          <span v-show="!isFinishing"> : {{ challenge.count_questions }} questões em {{ challenge.minutes }} minutos </span>
        </ModalTitle>
        <BtnClose @click="onClose()" />
      </div>
      <component
        :is="challengeComponent"
        :challenge="challenge"
        @onClose="onClose"
      />
    </div>
  </v-dialog>
</template>

<script>

import StartScreen from "./StartScreen";
import FinishScreen from "./FinishScreen";
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import ModalTitle from '@/student/components/ModalTitle'
import BtnClose from '@/common/components/BtnClose'
import ChallengeContent from '@/student/components/challenge/ChallengeContent'
import { defaultModalHeight } from '@/constants/general.js'

export default {
  components: {
    StartScreen,
    FinishScreen,
    ModalTitle,
    BtnClose,
    ChallengeContent
  },
  data() {
    return {
      defaultModalHeight
    }
  },
   computed: {
     dialogWidth(){
       switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '100vw'
          case 'sm': return "90vw"
          case 'md': return "90vw"
          case 'lg': return "90vw"
          case 'xl': return "90vw"
          default : return '90vw'
        }
     },
     challengeComponent(){
       if(this.$store.state.challenge.isFinishingCurrentChallenge){
         return 'FinishScreen'
       }else {
         return this.challenge && this.challenge.started_at ? 'ChallengeContent' : 'StartScreen'
       }
     },
    showModalChallenge: {
      get() {
        return this.$store.state.challenge.showModalChallenge;
      },
      set(value) {
        if(!value)
          this.SET_CHALLENGE();
        this.$store.commit('SHOW_MODAL_CHALLENGE', value);
      },
    },
    ...mapGetters(['current_cycle']),
    ...mapState({
      challenge: state => state.challenge.current,
      isFinishing: state => state.challenge.isFinishingCurrentChallenge,
    }),
  },
  mounted() {
    this.openModalIfQueryParamsExists();
  },
  methods:{
    ...mapMutations(['SET_CHALLENGE','SHOW_MODAL_CHALLENGE']),
    ...mapActions(['accessChallenge']),
    openModalIfQueryParamsExists(){
      if (this.$route.query.show_challenge_modal) {
        this.showModalChallenge = true;
        this.accessChallenge(!this.challenge && this.current_cycle.challenge ? { id: this.current_cycle.challenge.id } : {})
      }
    },
    onClose() {
      if (Object.keys(this.$route.query).length) {
        this.$router.replace({ query: '' })
      }
      this.showModalChallenge = false;
      this.SET_CHALLENGE();
    }
  }
}
</script>
